<p-table
  [value]="scheduleData()"
  [showGridlines]="true"
  [scrollable]="true"
  scrollHeight="flex"
  stripedRows
  class="p-datatable-sm lp-table"
  selectionMode="single"
  [metaKeySelection]="true"
  (onRowSelect)="onRowSelect()"
  [loading]="
    batchService.batchJobSceduleDatasource.isLoading() &&
    !batchService.batchJobSceduleDatasource.isLoaded()
  "
  [(selection)]="batchService.selectedBatchJobSchedule"
  dataKey="id"
  letKeepScrollPosition>
  <ng-template pTemplate="header">
    <tr>
      <th>Jobnavn</th>
      <th>Køres</th>
      <th>Frekvens</th>
      <th>Oprettet af</th>
    </tr>
  </ng-template>
  <ng-template [appTableRow]="scheduleData()" pTemplate="body" let-item>
    <tr [pSelectableRow]="item" class="cursor-pointer">
      <td>
        {{ item.jobNavn }}
      </td>
      <td class="numbers">
        {{ item.koerselsTidspunkt | date: 'dd-MM-yyyy HH:mm:ss' }}
      </td>
      <td>
        {{ item.frekvens }}
      </td>
      <td>{{ item.senestOpdateretAf }}</td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [header]="batchService.selectedBatchJobSchedule()?.jobNavn"
  [modal]="true"
  (onHide)="onHideJobDetails()"
  [(visible)]="showDetails"
  appendTo="body"
  [resizable]="true"
  contentStyleClass="!overflow-hidden h-full"
  [style]="{
    width: '80%',
    maxHeight: '90%',
    maxWidth: '1400px',
    height: '80%',
  }">
  @let job = batchService.selectedBatchJobSchedule();
  @if (job) {
    <app-batch-job-schedule-detail
      [batchJobSchedule]="job"
      (closeWindowRequest)="showDetails.set(false)"
      class="overflow-hidden h-full" />
  }
</p-dialog>
